import {FrameSize} from '../type/FrameSize.interface';
import {TextViewerCoreOption} from '../type/TextViewerCoreOption.type';
import {useCountTriggerTextViewerCoreOption} from './useCountTriggerTextViewerCoreOption.hook';
import {useNormalTextViewerCoreOption} from './useNormalTextViewerCoreOption.hook';

export function useTextViewerCoreOption(param: {
  size: FrameSize;
  isMobile: boolean;
}): TextViewerCoreOption {
  const normalOption = useNormalTextViewerCoreOption();
  const countTriggerOption = useCountTriggerTextViewerCoreOption(param);

  return {
    ...normalOption,
    ...countTriggerOption,
  };
}
